import eventBus from 'toxilibs/event_bus_queued.js'
import analytics from './libs/viewers.js'

eventBus.on('level changed', function (levelID) {
    analytics.emit('goToLevel', levelID)
})


eventBus.on('user won question', function (data) {
    analytics.emit('winReport', data.levelID + '_' + data.currentQuestionID, data.errors)
})


eventBus.on('end', function () {
    analytics.emit('gameFinished')
})


eventBus.on('challenge answer given', emitChallengeAnalyticsEvent)


function emitChallengeAnalyticsEvent (challenge, userAnswer, status) {

    const timeSpent = Math.round(challenge.totalTime / 1000)

    analytics.emit('answer_' + challenge.fullLabel, userAnswer, (status === 'win' ? 1 : 0))

    analytics.emit('timeToAnswer_' + challenge.fullLabel, status, timeSpent)

    analytics.emit(status, challenge.fullLabel, timeSpent)
}



